import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8090';

export interface LoginRequest {
  username: string;
  password: string;
}

export interface LoginResponse {
  token: string;
  message: string;
}

export interface ChatHistory {
  id: number;
  sessionId: string;
  userMessage: string;
  botResponse: string;
  createdAt: string;
}

export interface VectorGenerationResponse {
  success: boolean;
  totalProperties: number;
  successCount: number;
  errorCount: number;
  message: string;
}

export interface ScrapingResponse {
  message: string;
}

export interface ScrapingStatus {
  isRunning: boolean;
  status: string;
}

export interface NewPropertiesCheck {
  count: number;
  newProperties: string[];
}

export interface CustomerInquiry {
  id: number;
  sessionId: string;
  name?: string;
  phone?: string;
  email?: string;
  inquiryType: string;
  status: string;
  createdAt: string;
}

export const authApi = {
  login: async (credentials: LoginRequest): Promise<LoginResponse> => {
    const response = await axios.post(`${API_BASE_URL}/auth/login`, credentials);
    return response.data;
  },

  logout: async (token: string): Promise<void> => {
    await axios.post(`${API_BASE_URL}/auth/logout`, {}, {
      headers: { Authorization: `Bearer ${token}` }
    });
  },

  getChatHistory: async (token: string): Promise<ChatHistory[]> => {
    const response = await axios.get(`${API_BASE_URL}/admin/chat-history`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  generateAllEmbeddings: async (token: string): Promise<VectorGenerationResponse> => {
    const response = await axios.post(`${API_BASE_URL}/admin/vector/generate-all`, {}, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  startScraping: async (token: string): Promise<ScrapingResponse> => {
    const response = await axios.post(`${API_BASE_URL}/admin/scrape-properties`, {}, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  getScrapingStatus: async (token: string): Promise<ScrapingStatus> => {
    const response = await axios.get(`${API_BASE_URL}/admin/scraping-status`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  stopScraping: async (token: string): Promise<ScrapingResponse> => {
    const response = await axios.post(`${API_BASE_URL}/admin/stop-scraping`, {}, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  checkNewProperties: async (token: string): Promise<NewPropertiesCheck> => {
    const response = await axios.get(`${API_BASE_URL}/admin/check-new-properties`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  getCustomerInquiries: async (token: string): Promise<CustomerInquiry[]> => {
    const response = await axios.get(`${API_BASE_URL}/admin/customer-inquiries`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  }
};